import { Link, Text } from '@ltvco/refresh-lib/theme';
import { Email, PhoneIphone } from '@mui/icons-material';

import {
  StyledContactInfoStack,
  StyledContactRow,
  StyledContactContentStack,
  StyledContactFormRow,
  LinkButton,
  StyledSocialMediaRow,
} from 'components/DeepSearch/components/AccountPage/sections/NeedAssistance/components';
import { theme } from 'theme';

interface ContactInfoProps {
  supportEmail: string;
  supportPhone: string;
  customerSupportSchedule: {
    days: string;
    hours: string;
  };
  socialMedia: Array<{
    href: string;
    alternateTextContent?: string;
    icon?: React.ReactNode;
    hideOnSide?: boolean;
  }>;
  handleContactFormClick: () => void;
}
export const ContactInfo = ({
  supportEmail,
  supportPhone,
  customerSupportSchedule,
  socialMedia,
  handleContactFormClick,
}: ContactInfoProps) => {
  return (
    <StyledContactInfoStack>
      <StyledContactRow data-cy="cs_contact">
        <Email fontSize="small" sx={{ color: theme.palette.primary.main }} />
        <StyledContactContentStack>
          <Link
            href={`mailto:${supportEmail}`}
            target="_blank"
            rel="noreferrer noopener"
            color="primary"
          >
            {supportEmail}
          </Link>
          <Text variant="body2" fontWeight="400">
            Available 24 hours a day
          </Text>
          <StyledContactFormRow>
            <Text variant="body2" fontWeight="400">
              Or use our
            </Text>
            <LinkButton
              onClick={handleContactFormClick}
              data-cy="cs_contact_form_btn"
              variant="text"
              size="small"
              sx={{
                width: 'fit-content',
                textDecoration: 'none',
                fontWeight: '400',
              }}
            >
              contact form
            </LinkButton>
          </StyledContactFormRow>
        </StyledContactContentStack>
      </StyledContactRow>

      <StyledContactRow>
        <PhoneIphone
          fontSize="small"
          sx={{ color: theme.palette.primary.main }}
        />
        <StyledContactContentStack>
          <Link
            href={`tel:+${supportPhone}`}
            rel="noreferrer noopener"
            color="primary"
            sx={{ textDecoration: 'none', fontWeight: '400' }}
          >
            {supportPhone}
          </Link>
          <Text variant="body2" fontWeight="400">
            Available {customerSupportSchedule.hours}{' '}
          </Text>
          <Text variant="body2">{customerSupportSchedule.days}</Text>
        </StyledContactContentStack>
      </StyledContactRow>
      {socialMedia
        .filter(({ hideOnSide }) => !hideOnSide)
        .map(({ href, alternateTextContent, icon }, index: number) => {
          return (
            <StyledSocialMediaRow key={index}>
              {icon ?? null}
              <Link
                href={href}
                target="_blank"
                rel="noreferrer noopener"
                sx={{
                  padding: 0,
                  textDecoration: 'none',
                  fontWeight: '400',
                }}
                color="primary"
              >
                {alternateTextContent ?? href}
              </Link>
            </StyledSocialMediaRow>
          );
        })}
    </StyledContactInfoStack>
  );
};
